module.exports = __webpack_public_path__ + "static/media/cancelCalendar.f3fdb84a.svg";